import './Resources.css'
import noteToSelfImage from '../assets/resourceNoteToSelfJournal.jpg'
import spiritualDisciplinesImage from '../assets/resourceSpiritualDisciplinesHandbook.jpg'
import wakeUpToWonderImage from '../assets/resourceWakeUpToWonder.jpg'

const resources = [
  {
    title: 'Note to Self Journal',
    author: 'Rebekah Ballagh',
    image: noteToSelfImage,
    alt: 'Note to Self Journal by Rebekah Ballagh',
    link: 'https://www.journeytowellness.online/books',
    linkText: 'journeytowellness.online/books',
    description:
      'A practical journaling resource that supports reflection, emotional honesty, and wellbeing.',
  },
  {
    title: 'Spiritual Disciplines Handbook: Practices that Transform Us',
    author: 'Adele Ahlberg Calhoun',
    image: spiritualDisciplinesImage,
    alt: 'Spiritual Disciplines Handbook by Adele Ahlberg Calhoun',
    link: 'https://www.calhounministries.org/books',
    linkText: 'calhounministries.org/books',
    description:
      'A grounded guide to classic spiritual practices that can be adapted for modern ministry and discipleship contexts.',
  },
  {
    title: 'Wake Up to Wonder: 22 Invitations to Amazement in the Everyday',
    author: 'Karen Wright Marsh',
    image: wakeUpToWonderImage,
    alt: 'Wake Up to Wonder by Karen Wright Marsh',
    link: 'https://karenwrightmarsh.com/wake-up-to-wonder',
    linkText: 'karenwrightmarsh.com/wake-up-to-wonder',
    description:
      'A reflective invitation to notice wonder in everyday life through simple, accessible spiritual rhythms.',
  },
]

function Resources() {
  return (
    <div className="resources-page">
      <div className="resources-panel">
        <h1 className="resources-title">Resources</h1>
        <p className="resources-intro">
          The spiritual exercises used by Taha Wairua come from a range of
          trusted sources, both recent and ancient. Below are key resources
          that helped shape the program.
        </p>

        <div className="resources-grid">
          {resources.map((resource) => (
            <article className="resource-card" key={resource.title}>
              <div className="resource-image-wrap">
                <img
                  src={resource.image}
                  alt={resource.alt}
                  className="resource-image"
                />
              </div>
              <div className="resource-body">
                <h2 className="resource-title">{resource.title}</h2>
                <p className="resource-author">{resource.author}</p>
                <p className="resource-description">{resource.description}</p>
                <a
                  className="resource-link"
                  href={resource.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  {resource.linkText}
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Resources
